<div class="flex h-full flex-column md:flex-row">
  <div
    class="surface-0 pt-5 pb-3 h-full flex flex-column gap-3 flex-grow-1 surface-border border-right-1 md:max-w-23rem w-full">
    <div class="px-4 flex flex-column gap-3">
      <div class="surface-border border-1 border-round-xl surface-0 p-4 w-max">
        <app-logo hStyleClass="h-8rem w-12rem" [logoFileName]="config?.logo" />
      </div>

      <h1 class="m-0 text-2xl mb-5 font-semibold">
        {{
          config.headline ||
            globalStore.activeCommune()?.title ||
            globalStore.activeCommune()?.name
        }}
      </h1>

      <div
        class="surface-border border-1 pl-4 pr-2 py-2 w-full md:w-20rem flex flex-column cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round"
        (click)="callSearch()">
        <header>
          <h3 class="m-0 flex align-items-center gap-3 text-l font-semibold">
            <span>Suche starten</span>
            <div
              class="bg-primary border-round-3xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center">
              <i class="fas fa-search"></i>
            </div>
          </h3>
        </header>
      </div>

      <div
        class="surface-border border-1 pl-4 pr-2 py-2 w-full md:w-20rem flex flex-column cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round"
        (click)="closeLandingPage()">
        <header>
          <h3 class="m-0 flex align-items-center gap-3 text-l font-semibold">
            <span>Erstellen</span>
            <div
              class="bg-primary border-round-3xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center">
              <i class="fas fa-screwdriver-wrench"></i>
            </div>
          </h3>
        </header>
      </div>
    </div>

    <footer class="mt-auto flex flex-column gap-3">
      <div class="px-4">
        <div class="flex gap-3">
          <p-button
            label="Indikatoren"
            styleClass="surface-border"
            [outlined]="true"
            icon="fas fa-folder-tree"
            [rounded]="true"
            (click)="showTree()"></p-button>
          <p-button
            class="ml-auto"
            styleClass="surface-border"
            [outlined]="true"
            icon="fas fa-info"
            [rounded]="true"
            (click)="showInfo()"></p-button>
          <p-button
            styleClass="surface-border"
            [outlined]="true"
            icon="fas fa-ellipsis-vertical"
            [rounded]="true"
            (onClick)="menu.toggle($event)" />
        </div>
        <p-menu #menu [model]="menuItems" [popup]="true" styleClass="w-20rem">
          <ng-template pTemplate="item" let-item>
            @if (item.url) {
              <a class="p-menuitem-link" target="_blank" [href]="item.url">
                <div class="flex align-items-center">
                  <i class="p-menuitem-icon" [class]="item.icon"></i>
                  <div>
                    <span>{{ item.label }}</span>
                    @if (item.sub) {
                      <div class="text-xs text-color-secondary mt-2">
                        {{ item.sub }}
                      </div>
                    }
                  </div>
                </div>
              </a>
            } @else {
              <a
                class="p-menuitem-link"
                [routerLink]="item.routerLink"
                [target]="item.target || '_self'">
                <div class="flex align-items-center">
                  <i class="p-menuitem-icon" [class]="item.icon"></i>
                  <div>
                    <span>{{ item.label }}</span>
                    @if (item.sub) {
                      <div class="text-xs text-color-secondary mt-2">
                        {{ item.sub }}
                      </div>
                    }
                  </div>
                </div>
              </a>
            }
          </ng-template>
        </p-menu>
      </div>

      <div class="">
        <div class="flex flex-column gap-3">
          <div
            class="w-full px-4 py-3 border-top-1 border-bottom-1 surface-border">
            <app-logo hStyleClass="h-7rem w-20rem" />
          </div>
          <div class="flex gap-3 px-4">
            <a
              class="text-color font-semibold no-underline hover:underline text-sm"
              href="#"
              >Impressum</a
            >
            <a
              class="text-color font-semibold no-underline hover:underline text-sm"
              href="#"
              >Datenschutz</a
            >
          </div>
        </div>
      </div>
    </footer>
  </div>
  <div class="surface-ground w-full">
    <p-scrollPanel [style]="{ width: '100%', height: '100vh' }">
      <div class="flex flex-wrap p-3 w-full">
        @if (globalStore.communeConfiguration(); as config) {
          @if (checkDefaultBookmark()) {
            <div class="xl:w-8 md:w-6 w-full flex" (click)="callStartPage()">
              <div
                class="p-card m-3 p-4 flex flex-grow-1 flex-column bg-primary cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round-xl">
                <header>
                  <h3
                    class="mt-0 flex align-items-center gap-3 text-4xl font-semibold">
                    <span>Start</span>
                  </h3>
                </header>
                @if (config.startTeaser; as teaser) {
                  <div [innerHTML]="teaser"></div>
                }
                <footer class="mt-auto">
                  <p-button
                    [rounded]="true"
                    label="Startansicht laden"
                    styleClass="icon-inset"
                    icon="fas fa-arrow-right"></p-button>
                </footer>
              </div>
            </div>
          }
          @if (config.landingPageItems?.length) {
            @for (item of config.landingPageItems; track $index) {
              @if (enhancedLandingPageItem(item); as landingPageItem) {
                <div class="xl:w-4 md:w-6 w-full flex">
                  <div
                    class="p-4 p-card m-3 flex flex-grow-1 flex-column border-round-xl">
                    <header>
                      <h3
                        class="mt-0 flex align-items-center gap-3 font-semibold"
                        [ngClass]="{
                          'text-xl': landingPageItem.name.length > 20,
                          'text-2xl': landingPageItem.name.length <= 20,
                        }">
                        <span>{{ landingPageItem.name }}</span>
                        <div
                          class="bg-primary border-round-xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center text-base">
                          <i [class]="landingPageItem.icon"></i>
                        </div>
                      </h3>
                    </header>

                    @if (landingPageItem.text) {
                      <div
                        class="pb-3"
                        [innerHtml]="landingPageItem.text"></div>
                    }
                    <footer class="mt-auto">
                      <p-button
                        [rounded]="true"
                        [label]="getLabelByType(item.type)"
                        styleClass="icon-inset"
                        icon="fas fa-arrow-right"
                        (click)="landingPageItemCTA(item)"></p-button>
                    </footer>
                  </div>
                </div>
              }
            }
          } @else {}
        } @else {
          <h1 class="text-color-secondary m-3">Atlas in Zahlen</h1>
          <div class="w-full flex">
            <app-count-overview />
          </div>
        }
      </div>
    </p-scrollPanel>
  </div>
</div>

<p-dialog
  [modal]="true"
  [(visible)]="treeVisible"
  [style]="{ width: '60rem' }"
  header="Indikatoren explorieren">
  <div class="flex flex-column gap-3">
    @if (indicatorIds.length > 0) {
      <div
        class="-mx-3 p-3 surface-ground flex flex-column gap-3 sticky top-0 z-absolute-top surface-0 border-round-xl surface-border border-1">
        <div class="p-card p-3">
          <app-indicator-selection-list
            [indicatorIds]="indicatorIds"
            (unselectEvent)="
              unselectIndicator($event)
            "></app-indicator-selection-list>
        </div>
        <p-button
          [rounded]="true"
          class="ml-auto"
          label="Daten visualisieren"
          icon="fas fa-bolt"
          (click)="visualizeSelectedIndicators()"></p-button>
      </div>
    }

    <app-atlas-indicator-tree
      [combineableIndicatorIds]="combineableIndicators"
      (selectIndicator)="
        toggleIndicatorSelection($event)
      "></app-atlas-indicator-tree>
  </div>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="infoVisible" [style]="{ width: '60rem' }">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0"
      icon="fas fa-info-circle"
      [text]="'Funktionen auf der Startseite'"></app-header>
  </ng-template>
  <p>Liebe Nutzer:innen,</p>
  <p>
    herzlich willkommen im Kommunal-Atlas – dem Online-Tool für die anschauliche
    und individuelle Auswertung kommunaler Daten.
  </p>
  <p>
    Mit dem Kommunal-Atlas können Sie Daten der Stadt, Gemeinde oder des
    Landkreises einfach und interaktiv erkunden. Ob kleinräumige Vergleiche,
    zeitliche Entwicklungen oder unterschiedliche Darstellungsformen – der Atlas
    hilft dabei, Disparitäten, Trends und Zusammenhänge schnell zu erkennen und
    schafft eine Grundlage für Diskussion, Entscheidung oder Engagement.
  </p>

  <app-header styleClass="mt-6" text="Erste Orientierung"></app-header>

  <p>
    <b>Lesen:</b> Bereits zusammengestellte Themen, Berichte und Ansichten
    (sofern vorhanden) können Sie bequem über die weißen Buttons aufrufen und
    erkunden.
  </p>
  <p>
    <b>Selbst gestalten:</b> Wenn Sie eigene Auswertungen erstellen möchten,
    nutzen Sie die beiden zentralen Funktionen: „<i class="fas fa-search"></i>
    Suche“ und „<i class="fas fa-wrench"></i> Erstellen“.
  </p>

  <app-header styleClass="mt-6" icon="fas fa-search" text="Suche"></app-header>
  <p>
    Hier können Sie nach bestimmten Indikatoren, Räumen oder Ortsteilen, Themen,
    Berichten oder Ansichten suchen. Geben Sie einfach ein Stichwort ein – der
    Kommunal-Atlas erstellt mit einem Klick automatisch eine Ansicht bestehend
    aus verschiedenen Darstellungen.
  </p>
  <p>
    Probieren Sie es aus: Wählen Sie einzelne Indikatoren per Klick auf das
    <i class="fas fa-eye"></i> oder kombinieren Sie mehrere über das
    <i class="fas fa-plus-circle"></i> – so entsteht schnell eine interaktive
    Übersicht. Indikatoren lassen sich zusätzlich filtern und über Schlagworte
    eingrenzen.
  </p>

  <app-header
    styleClass="mt-6"
    icon="fas fa-screwdriver-wrench"
    text="Erstellen"></app-header>
  <p>
    Erstellen bietet Ihnen die Möglichkeit, eigene Ansichten zu bauen. Hier
    stellen Sie sich Ihre Datenansicht individuell zusammen – z. B. mit Karten,
    Kreisdiagrammen, Liniendiagrammen oder Tabellen. Alles lässt sich flexibel
    anpassen.
  </p>

  <app-header styleClass="mt-6" icon="" text="Weiße Buttons"></app-header>

  <p>
    Die weißen Buttons auf der Seite führen Sie direkt zu den verschiedenen
    Themen, Berichten und Ansichten, welche für Sie zusammengestellt wurden. So
    finden Sie schnell, was Sie interessiert.
  </p>
  <p>
    Schauen Sie sich in Ruhe um, probieren Sie die Funktionen aus und entdecken
    Sie, was in den kommunalen Daten steckt.
  </p>
  <p>Viel Spaß beim Erkunden!</p>
</p-dialog>
